<template>
  <div id="login">
    <!--<div class="ibg-bg"-->
    <!--:style="{'background-image': 'url('+ baseUrl + banner +') '}"></div>-->
    <div class="login-header">
      <div class="logo">
        <img style="width: 225px;" :src="baseUrl+'gc-logo.png'">
        <!--<a class="yun-logo" href="//pan.baidu.com/" target="_blank" title="吉凯网盘">吉凯网盘</a>-->
      </div>
    </div>

    <div class="ibg-bg-login" id="login-model">
      <div :style="{'background-image': 'url('+ baseUrl + banner +') '}">
        <div class="login-container">
          <!--账号密码登录-->
          <div v-if="!isLoginByVerifyCode" class="con-box" content="center" style="right: 6%;position: absolute;">
            <div style="margin-top: 50px;">
              <span>账号密码登录</span>
            </div>
            <div>
              <el-form status-icon ref="ruleForm2" class="demo-ruleForm">
                <el-form-item>
                  <el-input type="text" v-model="userName" placeholder="手机号／客户编号"></el-input>
                </el-form-item>
                <el-form-item prop="checkPass">
                  <el-input type="password" v-model="userPassword" placeholder="密码"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="login" style="width: 100%;" :disabled="disabledLoginBtn">登录
                  </el-button>
                </el-form-item>
                <div style="display: flex;flex-direction: row">
                  <el-form-item>
                    <el-button type="text" @click="isLoginByVerifyCode = true">验证码登录</el-button>
                    <!--<el-button type="text" @click="register">立即注册</el-button>-->
                  </el-form-item>
                  <el-form-item style="margin-left: 175px;">
                    <el-button type="text" @click="forgetPassword">忘记密码</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
          <!--验证码登录-->
          <div v-else class="con-box" content="center" style="right: 6%;position: absolute;">
            <div style="margin-top: 50px;">
              <span>验证码登录</span>
            </div>
            <div>
              <el-form status-icon ref="ruleForm2" class="demo-ruleForm">
                <el-form-item>
                  <el-input type="text" v-model="userMobile" placeholder="手机号"></el-input>
                </el-form-item>
                <el-form-item>
                  <div style="display: flex; flex-direction: row">
                    <el-input type="text" v-model="verifyCode" placeholder="验证码" style="margin-right: 12px;"></el-input>
                    <el-button type="primary" @click="sendVerifyCode" :loading="coolDown" :disabled="disabledSend">{{sendCodeText}}</el-button>
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="loginBySmsCode" style="width: 100%;" :disabled="disabledLoginByCodeBtn">登录
                  </el-button>
                </el-form-item>
                <div style="display: flex;flex-direction: row">
                  <el-form-item>
                    <el-button type="text" @click="isLoginByVerifyCode = false">账号密码登录</el-button>
                    <!--<el-button type="text" @click="register">立即注册</el-button>-->
                  </el-form-item>
                  <el-form-item style="margin-left: 160px;">
                    <el-button type="text" @click="forgetPassword">忘记密码</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div class="login-foot foot">
        <foot></foot>
      </div>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5'
import ct from '../../utils/constant.js'
import { mapState, mapMutations } from 'vuex'
import { setStorage, sendVerCode } from '../../utils/utils.js'
import foot from '../../components/Footer.vue'
export default {
  created () {
  },
  data () {
    return {
      userName: '',
      userPassword: '',
      baseUrl: 'static/img/',
      // banner: 'banner2.jpg'
      banner: 'background7.jpg',
      isLoginByVerifyCode: true,
      verifyCode: '',
      coolDown: false,
      sendVeriCodeSuccess: false,
      sendCodeText: '发送',
      userMobile: ''
    }
  },
  components: {
    foot
  },
  methods: {
    ...mapMutations(['setFilesList', 'setTagsList', 'setFileUploadingList', 'setSrcPage', 'setCustomerInfo']),
    login () {
      let param = {
        'LoginId': this.userName,
        'Password': md5(this.userPassword).toUpperCase()
      }
      let target = document.getElementById('login-model')
      let loading = this.$loading({test: '', target: target, spinner: 'el-icon-loading'})
      this.postRequest('gcwwwifc/login', param).then(res => {
        if (res && res.data.code === 0) {
          setStorage('user', res.data.result)
          this.setCustomerInfo(res.data.result)
          /**
           * this.getRequest('loadFileUploadRequests').then(res => {
            if (res && res.data.code === 0) {
              this.setFileUploadingList(res.data.result)
              this.getRequest('loadLoginInfo').then(res => {
                if (res && res.data.code === 0) {
                  let data = res.data.result
                  this.setStorage('externalNginxUrl', data.externalNginxUrl)
                  this.setStorage('sysDictionaries', data.sysDictionaries)
                  if (this.srcPage !== null) {
                    this.setSrcPage(ct.SrcPage.all)
                  }
                  this.$router.push(ct.RouterData.netDisk.path)
                  // window.getHomeData()
                } else {
                  this.$router.push(ct.RouterData.login.path)
                }
              })
            }
          })
           */
          return true
        } else {
          loading.close()
        }
      }).then(res => {
        if (res) {
          this.loadLoginInfoCommon(() => {
            loading.close()
          })
        }
      })
    },
    loadLoginInfoCommon (callback) {
      this.getRequest('loadLoginInfo').then(res => {
        callback()
        if (res && res.data.code === 0) {
          let data = res.data.result
          this.getSysInfo(data)
          if (this.srcPage !== null) {
            this.setSrcPage(ct.SrcPage.all)
          }
          this.$router.push(ct.RouterData.netDisk.path)
          // window.getHomeData()
        } else {
          this.$router.push(ct.RouterData.login.path)
        }
      })
    },
    forgetPassword () {
      this.$router.push(ct.RouterData.forgetPass.path)
    },
    // register () {
    //   this.$router.push(ct.RouterData.register.path)
    // }
    sendVerifyCode () {
      let phone = this.userMobile.replace(/\s+/g, '')
      if (!this.phoneVeri(phone)) {
        this.$message({message: '请输入11位正确格式的手机号码！', type: 'error'})
        return
      }
      sendVerCode(this, ct.SendVeriCodeType.login)
    },
    loginBySmsCode () {
      let target = document.getElementById('login-model')
      let loading = this.$loading({test: '', target: target, spinner: 'el-icon-loading'})
      this.postRequest('gcwwwifc/loginBySmsCode', {LoginId: this.userMobile, Password: this.verifyCode, Code: this.verifyCode}).then(res => {
        if (res.data) {
          if (res.data.code === 0) {
            setStorage('user', res.data.result)
            this.setCustomerInfo(res.data.result)
            return true
          } else if (res.data.code === 101) {
            this.$message.warning('验证码已过期，请重新点击发送按钮。')
            loading.close()
          } else {
            this.$message.error({message: res.data.message, duration: 5000})
            loading.close()
          }
        }
      }).then(res => {
        if (res) {
          this.loadLoginInfoCommon(() => {
            loading.close()
          })
        }
      })
    }
  },
  computed: {
    ...mapState(['filesList', 'srcPage']),
    disabledLoginBtn () {
      return this.userName === '' || this.userPassword === ''
    },
    disabledLoginByCodeBtn () {
      return this.userMobile === '' || this.verifyCode === ''
    },
    disabledSend () {
      return !this.userMobile || this.userMobile === ''
    }
  }
}
</script>
<style scoped>
  .login-header {
    position: absolute;
    height: 60px;
    width: 100%;
    left: 0;
    z-index: 3;
    background-color: white;
  }

  .login-title {
    /*float: right;*/
    /*margin: 17px 50px 0 0;*/
    margin-top: 1px;
  }

  .logo {
    /*background: url(/static/img/gc-logo.png) no-repeat scroll 0 transparent;*/
    float: left;
    height: 51px;
    margin: 17px 0 0 25px;
    overflow: hidden;
    width: 225px;
    display: inline;
  }

  .yun-logo {
    display: block;
    float: left;
    height: 44px;
    outline: medium none;
    text-indent: -9999em;
    width: 186px;
  }

  .b-no-ln {
    color: #1f2d3d;
    text-decoration: none;
    margin-left: 12px;
    font-weight: 700;
  }

  .el-message-box__message {
    text-align: center;
  }
  .ibg-bg-login {
    /*position:fixed;*/
    position: absolute;
    top: 60px;
    left: 0;
    width:100%;
    /*height: 700px;*/
    min-width: 1100px;
    z-index:-10;
    zoom: 1;
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
    -webkit-transition: background 1s;
    -moz-transition: background 1s;
    -o-transition: background 1s;
    transition: background 1s;
  }

  .login-container {
    /*margin-top: 60px;*/
    /*position: absolute;*/
    right: 3.5%;
    /*top: 160px;*/
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 700px;
    width: 100%;
  }

  .login-foot {
    height: 180px;
    background-color: white;
    /*position: absolute;*/
    /*z-index: 4;*/
    opacity: 1;
    text-align: center;
    bottom: 0;
    width: 100%;
  }

  .con-box {
    background-color: white;
    width: 400px;
    height: 400px;
    border-radius: 5px;
    float: right;
    z-index: 3;
    border: solid 1px gainsboro;
    opacity: 0.9;
  }

  .demo-ruleForm {
    padding: 30px 50px;
  }

  .p-footer {
    height: 10px;
    font-size: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue